import Vue from 'vue';
// import mutations from './mutations'
// import actions from './actions'
import moment from 'moment';
import { Backend } from '@/_axios';

export const LOAD_JIRA_WORKLOGS = 'LOAD_JIRA_WORKLOGS';
export const LOAD_SINGLE_PROJECT_JIRA_WORKLOGS = 'LOAD_SINGLE_PROJECT_JIRA_WORKLOGS';
export const SET_JIRA_WORKLOGS = 'SET_JIRA_WORKLOGS';

export const RESET_JIRA_WORKLOGS = 'RESET_JIRA_WORKLOGS';

export const LOAD_WORKLOGS_BY_PERIOD = 'LOAD_WORKLOGS_BY_PERIOD';
export const SET_JIRA_WORKLOGS_BY_PERIOD = 'SET_JIRA_WORKLOGS_BY_PERIOD';

export const LOAD_WORKLOGS_BY_PERIOD_TIMEFRAME = 'LOAD_WORKLOGS_BY_PERIOD_TIMEFRAME';
export const SET_WORKLOGS_BY_PERIOD_TIMEFRAME = 'SET_WORKLOGS_BY_PERIOD_TIMEFRAME';

const state = {
  worklogs: {},
  offset: 0,
  count: 4,
  weeks: [],
  endDate: '',
  curweek: null,
  timeframe: 'week', // TODO change back
  calendar: [],
  actualDate: null,
  actualDateDay: null,
  plannedByPeriod: []
};

const getters = {
  worklogsByAuthor: (state, getters, rootState, rootGetters) => {
    const worklogs = {};
    const timeIndexList = [];

    /* var users = rootGetters['JiraUsers/activeUsers'];
        for(let userID in users){
            worklogs[userID] = {
                total: {},
                byProject: {}
            };
        } */
    for (const worklogId in state.worklogs) {
      const worklog = state.worklogs[worklogId];
      const rate = rootGetters['UserRates/ratesOnDate'](worklog.date_started_at, worklog.author_id);
      worklogs[worklog.author_id] = worklogs[worklog.author_id] || {
        total: {},
        byProject: {}
      };

      var timeIndex;
      switch (state.timeframe) {
        case 'week':
          timeIndex = `${worklog.yearweek}`;
          break;
        case 'month':
          timeIndex = `${worklog.year}${worklog.month >= 10 ? worklog.month : `0${worklog.month}`}`; // e.g. 201805 instead of 20185
          break;
        case 'quarter':
          timeIndex = `${worklog.year}${worklog.quarter}`;
          break;
        case 'year':
          timeIndex = worklog.year;
          break;
      }

      if (!timeIndexList.includes(timeIndex)) timeIndexList.push(timeIndex);

      worklogs[worklog.author_id].total[timeIndex] = worklogs[worklog.author_id].total[timeIndex] || {
        time: 0,
        expenses: 0
      };

      worklogs[worklog.author_id].byProject[worklog.project_id] = worklogs[worklog.author_id].byProject[worklog.project_id] || {};
      worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex] = worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex] || {
        time: 0,
        expenses: 0
      };

      worklogs[worklog.author_id].total[timeIndex].time += parseInt(worklog.time_logged);
      worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex].time += parseInt(worklog.time_logged);

      worklogs[worklog.author_id].total[timeIndex].expenses += rate * parseInt(worklog.time_logged);
      worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex].expenses += rate * parseInt(worklog.time_logged);
    }

    /* //add projects which doesnt have logged hours, but has planned
        //console.log('state.plannedByPeriod', state.plannedByPeriod);
        for(let plannedWorkloadId in state.plannedByPeriod){
            let plannedWorkload = state.plannedByPeriod[plannedWorkloadId];
            if(!worklogs[plannedWorkload.user_id]){
                worklogs[plannedWorkload.user_id] = {
                    total: {},
                    byProject: {}
                };
            }
            if(!worklogs[plannedWorkload.user_id].byProject[plannedWorkload.project_id]){
                worklogs[plannedWorkload.user_id].byProject[plannedWorkload.project_id] = {};
            }
        }

        timeIndexList.sort();

        //fill holes
        for(var authorId in worklogs){
            timeIndexList.forEach(dateIndex => {
                if(!worklogs[authorId].total[dateIndex]){
                    worklogs[authorId].total[dateIndex] = {
                        time: 0,
                        expenses: 0
                    }
                }
            });
            for(var projectId in worklogs[authorId].byProject){
                timeIndexList.forEach(dateIndex => {
                    if(!worklogs[authorId].byProject[projectId][dateIndex]){
                        worklogs[authorId].byProject[projectId][dateIndex] = {
                            time: 0,
                            expenses: 0
                        }
                    }
                });
            }
        } */

    for (const plannedWorkloadId in state.plannedByPeriod) {
      const plannedWorkload = state.plannedByPeriod[plannedWorkloadId];
      if (!worklogs[plannedWorkload.user_id]) {
        worklogs[plannedWorkload.user_id] = {
          total: {},
          byProject: {}
        };
      }
      if (!worklogs[plannedWorkload.user_id].byProject[plannedWorkload.project_id]) {
        worklogs[plannedWorkload.user_id].byProject[plannedWorkload.project_id] = {};
      }
    }
    // fill holes

    for (var authorId in worklogs) {
      state.calendar.forEach((date) => {
        if (!worklogs[authorId].total[date.index]) {
          worklogs[authorId].total[date.index] = {
            time: 0,
            expenses: 0
          };
        }
      });
      for (var projectId in worklogs[authorId].byProject) {
        state.calendar.forEach((date) => {
          if (!worklogs[authorId].byProject[projectId][date.index]) {
            worklogs[authorId].byProject[projectId][date.index] = {
              time: 0,
              expenses: 0
            };
          }
        });
      }
    }

    return worklogs;
  },
  worklogsByAuthorByDay: (state, getters, rootState, rootGetters) => {
    const worklogs = {};
    for (const worklogId in state.worklogs) {
      const worklog = state.worklogs[worklogId];

      const rate = rootGetters['UserRates/ratesOnDate'](worklog.date_started_at, worklog.author_id);
      worklogs[worklog.author_id] = worklogs[worklog.author_id] || {
        total: {},
        byProject: {}
      };

      var timeIndex;
      switch (state.timeframe) {
        case 'week':
          timeIndex = `${worklog.yearweek}`;
          break;
        case 'month':
          timeIndex = `${worklog.year}${worklog.month >= 10 ? worklog.month : `0${worklog.month}`}`; // e.g. 201805 instead of 20185
          break;
        case 'quarter':
          timeIndex = `${worklog.year}${worklog.quarter}`;
          break;
        case 'year':
          timeIndex = worklog.year;
          break;
      }
      worklogs[worklog.author_id].total[timeIndex] = worklogs[worklog.author_id].total[timeIndex] || {
        time: 0,
        expenses: 0
      };

      worklogs[worklog.author_id].byProject[worklog.project_id] = worklogs[worklog.author_id].byProject[worklog.project_id] || {};
      worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex] = worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex] || {
        time: 0,
        expenses: 0
      };

      worklogs[worklog.author_id].total[timeIndex].time += parseInt(worklog.time_logged);
      worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex].time += parseInt(worklog.time_logged);

      worklogs[worklog.author_id].total[timeIndex].expenses += rate * parseInt(worklog.time_logged);
      worklogs[worklog.author_id].byProject[worklog.project_id][timeIndex].expenses += rate * parseInt(worklog.time_logged);
    }

    // add projects which doesnt have logged hours, but has planned
    // console.log('state.plannedByPeriod', state.plannedByPeriod);
    for (const plannedWorkloadId in state.plannedByPeriod) {
      const plannedWorkload = state.plannedByPeriod[plannedWorkloadId];
      if (!worklogs[plannedWorkload.user_id]) {
        worklogs[plannedWorkload.user_id] = {
          total: {},
          byProject: {}
        };
      }
      if (!worklogs[plannedWorkload.user_id].byProject[plannedWorkload.project_id]) {
        worklogs[plannedWorkload.user_id].byProject[plannedWorkload.project_id] = {};
      }
    }
    // fill holes
    for (var authorId in worklogs) {
      state.calendar.forEach((date) => {
        if (!worklogs[authorId].total[date.index]) {
          worklogs[authorId].total[date.index] = {
            time: 0,
            expenses: 0
          };
        }
      });
      for (var projectId in worklogs[authorId].byProject) {
        state.calendar.forEach((date) => {
          if (!worklogs[authorId].byProject[projectId][date.index]) {
            worklogs[authorId].byProject[projectId][date.index] = {
              time: 0,
              expenses: 0
            };
          }
        });
      }
    }
    return worklogs;
  },
  worklogsByProject: (state, getters, rootState, rootGetters) => {
    const worklogs = {};
    for (const worklogId in state.worklogs) {
      const worklog = state.worklogs[worklogId];
      worklogs[worklog.project_id] = worklogs[worklog.project_id] || {
        total: {},
        byUser: {}
      };
      const rate = rootGetters['UserRates/ratesOnDate'](worklog.date_started_at, worklog.author_id);
      var timeIndex;
      switch (state.timeframe) {
        case 'week':
          timeIndex = `${worklog.yearweek}`;
          break;
        case 'month':
          timeIndex = `${worklog.year}${worklog.month >= 10 ? worklog.month : `0${worklog.month}`}`; // 201805 instead of 20185
          break;
        case 'quarter':
          timeIndex = `${worklog.year}${worklog.quarter}`;
          break;
        case 'year':
          timeIndex = worklog.year;
          break;
      }
      worklogs[worklog.project_id].total[timeIndex] = worklogs[worklog.project_id].total[timeIndex] || {
        time: 0,
        expenses: 0,
        date: worklog.date_started_at,
        firstDayOfWeek: moment(new Date(worklog.date_started_at)).startOf('isoWeek').format('YYYY-MM-DD'),
        lastDayOfWeek: moment(new Date(worklog.date_started_at)).endOf('isoWeek').format('YYYY-MM-DD')
      };
      worklogs[worklog.project_id].byUser[worklog.author_id] = worklogs[worklog.project_id].byUser[worklog.author_id] || {
        total: {},
        byProject: {}
      };
      worklogs[worklog.project_id].byUser[worklog.author_id].total[timeIndex] = worklogs[worklog.project_id].byUser[worklog.author_id].total[timeIndex] || {
        time: 0,
        expenses: 0
      };
      worklogs[worklog.project_id].total[timeIndex].time += parseInt(worklog.time_logged);
      worklogs[worklog.project_id].total[timeIndex].expenses += parseInt(worklog.time_logged) * rate;
      worklogs[worklog.project_id].byUser[worklog.author_id].total[timeIndex].time += parseInt(worklog.time_logged);
      worklogs[worklog.project_id].byUser[worklog.author_id].total[timeIndex].expenses += parseInt(worklog.time_logged) * rate;
    }
    // fill holes
    for (var projectId in worklogs) {
      state.calendar.forEach((date) => {
        if (!worklogs[projectId].total[date.index]) {
          worklogs[projectId].total[date.index] = {
            time: 0,
            expenses: 0
          };
        }
      });
      for (var authorId in worklogs[projectId].byUser) {
        state.calendar.forEach((date) => {
          if (!worklogs[projectId].byUser[authorId].total[date.index]) {
            worklogs[projectId].byUser[authorId].total[date.index] = {
              time: 0,
              expenses: 0
            };
          }
        });
      }
    }
    return worklogs;
  },
  worklogsByCategory: (state, getters, rootState, rootGetters) => {
    const worklogs = {};
    const stateWorklogs = state.worklogs;

    for (const categoryID in rootGetters['Projects/projectCategories']) {
      const category = rootGetters['Projects/projectCategories'][categoryID];

      for (const projectID in rootGetters['Projects/projects']) {
        const project = rootGetters['Projects/projects'][projectID];

        for (const worklogId in stateWorklogs) {
          const worklog = stateWorklogs[worklogId];

          worklogs[category.id] = worklogs[category.id] || {};

          if (worklog.project_id === project.id && project.category_id === category.id) {
            worklogs[category.id][worklog.project_id] = worklogs[category.id][worklog.project_id] || {
              total: {},
              byUser: {},
              project_id: project.id,
              project_name: project.name,
            };
            const rate = rootGetters['UserRates/ratesOnDate'](worklog.date_started_at, worklog.author_id);
            var timeIndex;
            switch (state.timeframe) {
              case 'week':
                timeIndex = `${worklog.yearweek}`;
                break;
              case 'month':
                timeIndex = `${worklog.year}${worklog.month >= 10 ? worklog.month : `0${worklog.month}`}`; // 201805 instead of 20185
                break;
              case 'quarter':
                timeIndex = `${worklog.year}${worklog.quarter}`;
                break;
              case 'year':
                timeIndex = worklog.year;
                break;
            }
            worklogs[category.id][worklog.project_id].total[timeIndex] = worklogs[category.id][worklog.project_id].total[timeIndex] || {
              time: 0,
              expenses: 0,
              date: worklog.date_started_at,
              firstDayOfWeek: moment(new Date(worklog.date_started_at)).startOf('isoWeek').format('YYYY-MM-DD'),
              lastDayOfWeek: moment(new Date(worklog.date_started_at)).endOf('isoWeek').format('YYYY-MM-DD')
            };
            worklogs[category.id][worklog.project_id].byUser[worklog.author_id] = worklogs[category.id][worklog.project_id].byUser[worklog.author_id] || {
              total: {},
              byProject: {}
            };
            worklogs[category.id][worklog.project_id].byUser[worklog.author_id].total[timeIndex] = worklogs[category.id][worklog.project_id].byUser[worklog.author_id].total[timeIndex] || {
              time: 0,
              expenses: 0
            };
            worklogs[category.id][worklog.project_id].total[timeIndex].time += parseInt(worklog.time_logged);
            worklogs[category.id][worklog.project_id].total[timeIndex].expenses += parseInt(worklog.time_logged) * rate;
            worklogs[category.id][worklog.project_id].byUser[worklog.author_id].total[timeIndex].time += parseInt(worklog.time_logged);
            worklogs[category.id][worklog.project_id].byUser[worklog.author_id].total[timeIndex].expenses += parseInt(worklog.time_logged) * rate;

            // delete worklogs[category.id][worklog.project_id];
          }
        }
        // fill holes
        for (var categoryId in worklogs) {
          const categoryData = worklogs[categoryId];

          for (var projectId in categoryData) {
            state.calendar.forEach((date) => {
              if (!worklogs[categoryId][projectId].total[date.index]) {
                worklogs[categoryId][projectId].total[date.index] = {
                  time: 0,
                  expenses: 0
                };
              }
            });
            for (var authorId in worklogs[categoryId][projectId].byUser) {
              state.calendar.forEach((date) => {
                if (!worklogs[categoryId][projectId].byUser[authorId].total[date.index]) {
                  worklogs[categoryId][projectId].byUser[authorId].total[date.index] = {
                    time: 0,
                    expenses: 0
                  };
                }
              });
            }
          }
        }
      }
    }

    return worklogs;
  },
  worklogsByPeriod: (state, getters, rootState, rootGetters) => {
    const worklogs = {};
    const stateWorklogs = state.worklogs;
  },
  datesByYearweek: (state) => {
    const dates = {};
    state.weeks.forEach((week) => {
      dates[week.yearweek] = week.date;
    });
    return dates;
  },
  yearweeksByDate: (state) => {
    const weeks = {};
    state.weeks.forEach((week) => {
      weeks[week.date] = week.yearweek;
    });
    return weeks;
  },
  curweek: (state) => {
    return state.curweek;
  },
  weeks: (state) => {
    return state.weeks;
  },
  weekOffset: (state) => {
    return state.weekOffset;
  },
  weekCount: (state) => {
    return state.weekCount;
  },
  endDate: (state) => {
    return new Date(state.endDate);
  },
  calendar: (state) => {
    return state.calendar;
  },
  timeframe: (state) => {
    return state.timeframe;
  },
  offset: (state) => {
    return state.offset;
  },
  count: (state) => {
    return state.count;
  },
  actualDate: (state) => {
    return state.actualDate;
  },
  actualDateDay: (state) => {
    return state.actualDateDay;
  },
  plannedByPeriod: (state) => {
    return state.plannedByPeriod;
  },
  worklogs: (state) => {
    return state.worklogs;
  }
};

function calculateCalendar(response, timeframe, count, offset) {
  const worklogs = {};
  response.data.forEach((worklog) => {
    worklogs[worklog.id] = worklog;
  });
  let actualDate;
  const curDate = new Date();
  const endDate = new Date();
  const actualDateDay = moment(curDate).format('YYYY-MM-DD');
  const calendar = [];
  switch (timeframe) {
    case 'week':
      actualDate = moment(curDate).format('GGGGWW');
      curDate.setDate(curDate.getDate() - (offset * 7));
      endDate.setDate(endDate.getDate() - ((offset + count) * 7));
      break;
    case 'month':
      actualDate = moment(curDate).format('YYYYMM');
      curDate.setMonth(curDate.getMonth() - offset);
      endDate.setMonth(endDate.getMonth() - (offset + count));
      break;
    case 'quarter':
      actualDate = moment(curDate).format('YYYYQ');
      curDate.setMonth(curDate.getMonth() - (offset * 3));
      endDate.setMonth(endDate.getMonth() - ((offset + count) * 3));
      break;
    case 'year':
      actualDate = moment(curDate).format('YYYY');
      curDate.setFullYear(curDate.getFullYear() - offset);
      endDate.setFullYear(endDate.getFullYear() - (offset + count));
      break;
  }
  while (endDate < curDate) {
    switch (timeframe) {
      case 'week':
        endDate.setDate(endDate.getDate() + 7);
        calendar.push({ date: new Date(endDate.getTime()),
          index: moment(endDate).startOf('isoWeek').format('GGGGWW'),
          indexToView: moment(endDate).startOf('isoWeek').format('GGGG WW'),
          string: moment(endDate).startOf('isoWeek').format('YYYY-MM-DD') });
        break;
      case 'month':
        endDate.setMonth(endDate.getMonth() + 1);
        calendar.push({ date: new Date(endDate.getTime()),
          index: moment(endDate).format('YYYYMM'),
          string: moment(endDate).format('YYYY-MM-DD') });
        break;
      case 'quarter':
        endDate.setMonth(endDate.getMonth() + 3);
        calendar.push({ date: new Date(endDate.getTime()),
          index: moment(endDate).format('YYYYQ'),
          string: moment(endDate).format('YYYY-MM-DD') });
        break;
      case 'year':
        endDate.setFullYear(endDate.getFullYear() + 1);
        calendar.push({ date: new Date(endDate.getTime()),
          index: endDate.getFullYear(),
          string: moment(endDate).format('YYYY-MM-DD') });
        break;
    }
  }
  const responseData = {
    calendar: calendar,
    actualDate: actualDate,
    worklogs: worklogs,
    actualDateDay: actualDateDay
  };
  return responseData;
}

function calculateCalendarByPeriod(response, timeframe, dateFrom, dateTo) {
  const worklogs = {};

  response.data.worklogs.forEach((worklog) => {
    worklogs[worklog.id] = worklog;
  });

  let actualDate;
  const curDate = new Date();
  const startDate = moment(dateFrom);
  const endDate = moment(dateTo).endOf(timeframe);
  const actualDateDay = moment(curDate).subtract(1, 'day').format('YYYY-MM-DD');

  const calendar = [];

  while (startDate <= endDate) {
    switch (timeframe) {
      case 'week':
        actualDate = moment(curDate).subtract(1, 'day').format('GGGGWW');
        calendar.push({
          date: startDate.format(),
          index: startDate.startOf('isoWeek').format('GGGGWW'),
          indexToView: startDate.startOf('isoWeek').format('GGGG WW'),
          string: startDate.startOf('isoWeek').format('YYYY-MM-DD') });
        startDate.add(7, 'days');
        break;
      case 'month':
        actualDate = moment(curDate).subtract(1, 'day').format('YYYYMM');
        calendar.push({
          date: startDate.format(),
          index: startDate.format('YYYYMM'),
          indexToView: startDate.startOf('month').format('MMMM MM'),
          string: startDate.format('YYYY-MM-DD') });
        startDate.add(1, 'month');
        break;
      case 'quarter':
        actualDate = moment(curDate).subtract(1, 'day').format('YYYYQ');
        calendar.push({
          date: startDate.format(),
          index: startDate.format('YYYYQ'),
          indexToView: startDate.startOf('quarter').format('YYYY [Q]Q'),
          string: startDate.format('YYYY-MM-DD') });
        startDate.add(3, 'months');
        break;
      case 'year':
        actualDate = moment(curDate).subtract(1, 'day').format('YYYY');
        calendar.push({
          date: startDate.format(),
          index: startDate.getFullYear(),
          indexToView: startDate.startOf('year').format('YYYY'),
          string: startDate.format('YYYY-MM-DD') });
        startDate.add(1, 'year');
        break;
    }
  }
  return {
    calendar: calendar,
    actualDate: actualDate,
    worklogs: worklogs,
    actualDateDay: actualDateDay
  };
}

const actions = {
  [LOAD_JIRA_WORKLOGS]: function ({ commit }, { offset, count, timeframe }) {
    Backend.get('/api/jira-latest-worklogs', { params: { unit: timeframe, offset: offset, count: count } }).then((response) => {
      const calculatedData = calculateCalendar(response, timeframe, count, offset);
      commit('SET_JIRA_WORKLOGS', {
        worklogs: calculatedData.worklogs,
        calendar: calculatedData.calendar,
        timeframe: timeframe,
        offset: offset,
        count: count,
        actualDate: calculatedData.actualDate,
        actualDateDay: calculatedData.actualDateDay
      });
    });
  },
  [LOAD_SINGLE_PROJECT_JIRA_WORKLOGS]: function ({ commit, state }, { project_id, offset, count, timeframe }) {
    Backend.get('/api/single-project-jira-latest-worklogs', { params: { project_id: project_id, unit: timeframe, offset: offset, count: count } }).then((response) => {
      const calculatedData = calculateCalendar(response, timeframe, count, offset);
      commit('SET_JIRA_WORKLOGS', {
        worklogs: calculatedData.worklogs,
        calendar: calculatedData.calendar,
        timeframe: timeframe,
        offset: offset,
        count: count,
        actualDate: calculatedData.actualDate,
        actualDateDay: calculatedData.actualDateDay
      });
    });
  },
  [RESET_JIRA_WORKLOGS]: function () {
    Backend.post('/api/jira-reset-worklogs');
  },
  [LOAD_WORKLOGS_BY_PERIOD]: function ({ commit, dispatch }, { periodFrom, periodTo }) {
    Backend.get('/api/load-jira-worklogs-by-period', { params: { periodFrom: periodFrom, periodTo: periodTo } }).then((response) => {
      const worklogs = {};
      response.data.worklogs.forEach((worklog) => {
        worklogs[worklog.id] = worklog;
      });

      let actualDate; let
        actualDateDay;
      const start = moment(periodFrom).startOf('isoWeek').format('YYYY-MM-DD');
      const startDate = new Date(start);
      const endDate = new Date(periodTo);
      const curDate = new Date();
      // var endDate = new Date();
      const calendar = [];

      actualDate = moment(curDate).format('GGGGWW');
      actualDateDay = moment(curDate).format('YYYY-MM-DD');
      // curDate.setDate(curDate.getDate() - (offset * 7));
      // endDate.setDate(endDate.getDate() - ((offset+count) * 7));
      while (startDate <= endDate) {
        calendar.push({ date: new Date(startDate.getTime()),
          index: moment(startDate).startOf('isoWeek').format('GGGGWW'),
          indexToView: moment(startDate).startOf('isoWeek').format('GGGG WW'),
          string: moment(startDate).startOf('isoWeek').format('YYYY-MM-DD') });
        startDate.setDate(startDate.getDate() + 7);
      }
      commit('SET_JIRA_WORKLOGS_BY_PERIOD', {
        worklogs: worklogs,
        calendar: calendar,
        actualDate: actualDate,
        plannedByPeriod: response.data.plannedWorkloads,
        actualDateDay: actualDateDay
      });
    }, (err) => {
      console.log(err);
    });
  },
  [LOAD_WORKLOGS_BY_PERIOD_TIMEFRAME]: function ({ commit, dispatch }, { periodFrom, periodTo, timeframe }) {
    Backend.get('/api/load-jira-worklogs-by-period', { params: { periodFrom: periodFrom, periodTo: periodTo, timeframe: timeframe } }).then((response) => {
      const calculatedData = calculateCalendarByPeriod(response, timeframe, periodFrom, periodTo);
      commit('SET_WORKLOGS_BY_PERIOD_TIMEFRAME', {
        worklogs: calculatedData.worklogs,
        calendar: calculatedData.calendar,
        timeframe: timeframe,
        actualDate: calculatedData.actualDate,
        plannedByPeriod: response.data.plannedWorkloads,
        actualDateDay: calculatedData.actualDateDay
      });
    }, (err) => {
      console.log(err);
    });
  },
};

const mutations = {
  [SET_JIRA_WORKLOGS]: function (state, { worklogs, calendar, timeframe, offset, count, actualDate, actualDateDay }) {
    Vue.set(state, 'worklogs', worklogs);
    Vue.set(state, 'calendar', calendar);
    Vue.set(state, 'timeframe', timeframe);
    Vue.set(state, 'offset', offset);
    Vue.set(state, 'count', count);
    Vue.set(state, 'actualDate', actualDate);
    Vue.set(state, 'actualDateDay', actualDateDay);
  },
  [SET_JIRA_WORKLOGS_BY_PERIOD]: function (state, { worklogs, calendar, actualDate, plannedByPeriod, actualDateDay }) {
    Vue.set(state, 'plannedByPeriod', plannedByPeriod);
    Vue.set(state, 'worklogs', worklogs);
    Vue.set(state, 'calendar', calendar);
    Vue.set(state, 'actualDate', actualDate);
    Vue.set(state, 'actualDateDay', actualDateDay);
  },
  [SET_WORKLOGS_BY_PERIOD_TIMEFRAME]: function (state, { worklogs, calendar, timeframe, actualDate, plannedByPeriod, actualDateDay }) {
    Vue.set(state, 'plannedByPeriod', plannedByPeriod);
    Vue.set(state, 'timeframe', timeframe);
    Vue.set(state, 'worklogs', worklogs);
    Vue.set(state, 'calendar', calendar);
    Vue.set(state, 'actualDate', actualDate);
    Vue.set(state, 'actualDateDay', actualDateDay);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
